import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
    },
    container: {
        width: "100%",
    },
    titleContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    title: {
        color: theme.palette.primary.dark,
    },
    progressBar: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    downtime: {
        height: 8,
        backgroundColor: theme.palette.error.main,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
    },
    uptime: {
        height: 8,
        backgroundColor: theme.palette.success.main,
        borderTopLeftRadius: 50,
        borderBottomLeftRadius: 50,
        textAlign: "right",
        marginRight: theme.spacing(0.5),
    },
    percentageNumber: {
        fontSize: "16px !important",
    },
}));
